const KEY = 'GLOBAL_STORE';

export default KEY;
